module.exports = __webpack_public_path__ + "img/shujuchanping.498911d6.png";